import { usePaginatedMasterData } from './usePaginatedMasterData';
import { getLocations } from '../services/locationService';
import type { LocationListFilters, LocationListItem } from '../types/location';
import { activeConfigurationFilters } from '../utils/configurationFilters';

const EMPTY_FILTERS: LocationListFilters = activeConfigurationFilters();

export function useLocations() {
  return usePaginatedMasterData<LocationListItem, LocationListFilters>({
    getId: item => item.locationId,
    initialFilters: EMPTY_FILTERS,
    errorMessage: 'Unable to load locations.',
    loadPage: async ({ page, pageSize, search, filters }) =>
      getLocations({
        page,
        pageSize,
        filters: {
          ...filters,
          search: search || undefined,
        },
      }),
  });
}
